//#region Libraries
import styled from "styled-components";
//#endregion
import { Column } from "components/styles";

export const Container = styled.article`
    display: grid;
    place-items: center;
    padding: 55px 50px;
    & img {
        width: 300px;
    }
`;
export const Content = styled(Column)`
    width: 46%;
    align-items: center;
    justify-content: center;
    @media (max-width: 800px) {
        width: 100%;
    }
`;
export const Title = styled.h3`
    font-weight: 900;
    color: var(--dark-4);
    text-align: center;
    margin: 0;
    margin-top: 10px;
`;
export const TextList = styled.ol`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0;
    list-style: none;
    & p, li {
        padding: 0;
        color: var(--light-gray-5);
        line-height: 20px;
        font-size: 14px;
        text-align: center;
    }
    & p {
        margin: 0;
    }
    & b {
        color: var(--dark-4);
    }
`;